<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.searchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getProjectUserTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">客户经理项目人账号列表</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="$checkAccessArray(['S'])"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onEditRole">角色</Button>
                        <Button v-if="$checkAccessArray(['S'])"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCreateProjectUser">新增</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.searchCardShow = !mainTable.searchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="mainTable.data"
                    :extHeight="60"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getProjectUserTableRecords" />
                </Col>
            </Row>
        </Card>

        <ProjectUserEdit ref="projectUserModal" :departmentList="departmentList" :companyList="companyList"/>
        <RoleEdit ref="roleEdit"/>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { approvalFormat, statusFormat } from '@/libs/baseModelFormat';
import { dateRender } from '@/libs/tableRowTimeRender';
import ProjectUserEdit from './project-manage-edit';
import RoleEdit from '@/view/account-management/role-management/role-edit.vue';
import { getInspectorUserList } from '@/api/modules/account-management/inspector-user-management';

// 项目用户管理列表组件
export default {
    name: 'ProjectUserList',
    props: {
        departmentList: {
            type: Array,
            default: () => []
        },
        companyList: {
            type: Array,
            default: () => []
        }
    },
    components: {
        SearchCard,
        StandPaginationTable,
        ProjectUserEdit,
        RoleEdit
    },
    data() {
        return {
            // 主表格配置
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '登录账号', key: 'userName', align: 'center' },
                    { title: '姓名', key: 'userPersonName', align: 'center' },
                    { title: '角色名称', key: 'name', align: 'center' },
                    { title: '手机号码', key: 'userPhone', align: 'center' },
                    {
                        title: '状态',
                        key: 'userStatus',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, statusFormat(params.row.userStatus))
                            ]);
                        }
                    },
                    { title: '创建时间', key: 'userCreateAt', align: 'center', render: (h, params) => dateRender(h, params.row.userCreateAt) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {
                                    },
                                    on: {
                                        click: () => {
                                            this.onUpdateProjectUser(params.row);
                                        }
                                    }
                                }, '编辑')
                            ]);
                        }
                    }
                ],
                data: [],
                searchCardShow: false,
                // 搜索表单配置
                searchForm: [
                    { label: '登录账号', type: 'Input', value: '', name: 'userName', sql: 'like' },
                    { label: '姓名', type: 'Input', value: '', name: 'userPersonName', sql: 'like' },
                    { label: '状态', type: 'Select', name: 'userStatus', sql: 'in', options: [{ value: 1, key: '激活' }, { value: -1, key: '冻结' }] },
                    { label: '部门', type: 'Select', name: 'departmentUuid', sql: 'in', options: [] },
                    { label: '公司', type: 'Select', name: 'companyUuid', sql: 'in', options: [] }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getProjectUserTableRecords();
    },
    methods: {
        // 获取项目用户表格数据
        getProjectUserTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.tableSearch.userType = 'P';
            getInspectorUserList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.loading = false;
            }).catch(() => {
                this.mainTable.loading = false;
            });
        },
        onCreateProjectUser() {
            this.$refs.projectUserModal.showModal('');
        },
        onUpdateProjectUser(userRow) {
            this.$refs.projectUserModal.showModal(userRow.userUuid);
        },
        onEditRole(){
            this.$refs.roleEdit.openRoleEditModal("客户经理项目人");
        }
    }
};
</script>

<style scoped>
</style>
